import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import { useSelector } from 'react-redux'
import { convertToUserDateFormate } from 'utils/helpers'

function ListOperations({ fetchOperations, operations, setSelectedRows, fetchOperations2 }) {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  const siteUser = useSelector((store) => store.user)
  const gridRef = useRef(null)
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  const handleScroll = () => {
    const gridElement = document.querySelector('.MuiDataGrid-virtualScroller')
    const { scrollTop, scrollHeight, clientHeight } = gridElement
    if (scrollTop + clientHeight >= scrollHeight) {
      let url = `&limit=${rows}&offset=${operations.results.length}`
      fetchOperations2(url)
    }
  }
  useEffect(() => {
    const gridElement = document.querySelector('.MuiDataGrid-virtualScroller')

    if (gridElement) {
      gridElement.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (gridElement) {
        gridElement.removeEventListener('scroll', handleScroll)
      }
    }
  }, [operations])

  useEffect(() => {
    // setTTs(!tts)
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Date',
          headerName: t('finance.gestionOperations.date'),
          width: 220,
          renderCell: (params) => (
            <Box py={2} mt={1}>
              <Box fontWeight={600}>{convertToUserDateFormate(siteUser.user, params.row.Date)}</Box>
              <Box>
                <Box component={'span'}>{t('finance.gestionOperations.label')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Libelle}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>{t('finance.gestionOperations.categoryLabel')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Categorie}
                </Box>
              </Box>
              <Box>
                <Box component={'span'}>{t('finance.gestionOperations.subCategory')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.SousCategorie.length ? params.row.SousCategorie[0].SousCategorie : ''}
                </Box>
              </Box>
            </Box>
          ),
        },
        {
          field: 'Montant',
          headerName: t('finance.gestionOperations.amount'),
          width: 110,
          renderCell: (params) => (
            <Box py={2}>
              <Box component={'span'}>{params.row.Montant}</Box>
              <Box component={'span'}>{params.row.NCompte?.Devise}</Box>
            </Box>
          ),
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile])

  const columns = [
    {
      field: 'Date',
      headerName: t('finance.gestionOperations.date'),
      width: 100,
      editable: true,
      type: 'date',
      renderCell: (params) => convertToUserDateFormate(siteUser.user, params.row.Date),
    },
    {
      field: 'NumeroCompte',
      headerName: t('finance.gestionOperations.accountNumber'),
      type: 'number',
      width: 100,
      valueGetter: (params) => `${params.row.NCompte ? params.row.NCompte.NumeroCompte : 'N/A'}`,
    },
    {
      field: 'compte',
      headerName: t('finance.gestionOperations.accountName'),
      width: 150,
      editable: true,
    },
    {
      field: 'Libelle',
      headerName: t('finance.gestionOperations.label'),
      width: 400,
      editable: true,
    },
    {
      field: 'Montant',
      headerName: t('finance.gestionOperations.amount'),
      width: 100,
      editable: true,
      type: 'number',
      renderCell: (params) => params.row.Montant,
    },
    {
      field: 'Categorie',
      headerName: t('finance.gestionOperations.categoryLabel'),
      width: 180,
      valueGetter: (params) =>
        `${params.row.SousCategorie.length > 0 ? params.row.SousCategorie[0].Categorie : 'N/A'}`,
    },
    {
      field: 'SousCategorie',
      headerName: t('finance.gestionOperations.subCategory'),
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 180,
      valueGetter: (params) =>
        `${params.row.SousCategorie.length ? params.row.SousCategorie[0].SousCategorie : 'N/A'}`,
    },
  ]
  return (
    <div
      style={{
        height: 700,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
        marginBottom: '66px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {t('finance.gestionOperations.myOperations')} ({operations.count})
      </Typography>

      <DataGrid
        sx={{
          '.MuiTablePagination-toolbar': {
            alignItems: 'baseline',
          },
          '.MuiDataGrid-footerContainer': {
            background: 'white',
          },
        }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {t('finance.gestionOperations.noData')}
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {t('finance.gestionOperations.noData')}
            </Stack>
          ),
        }}
        checkboxSelection

        // onRowsScrollEnd={handleScrollToBottom}
      />
    </div>
  )
}
export default ListOperations
